module.exports = __webpack_public_path__ + "static/media/que-hacer-en-palermo.8ef94897.md";